import type { RequestBody } from '@vrplatform/data';
import type { listingOwnershipPeriodBusinessModel_enum } from '@vrplatform/graphql';
import { type Maybe, bankersRound, day } from '@vrplatform/utils';

type ListingPeriodMemberInput = {
  ownerId: string | null;
  splitBasePoints: number;
};

type ListingPeriodRequestInput = {
  listingId: string;
  startDate: Maybe<string>;
  endDate: Maybe<string>;
  businessModel?: listingOwnershipPeriodBusinessModel_enum;
  reserveCentTotal: number;
  members: ListingPeriodMemberInput[];
};

export const getListingPeriodRequestBody = ({
  listingId,
  startDate,
  endDate,
  businessModel,
  reserveCentTotal,
  members,
}: ListingPeriodRequestInput): RequestBody<'post:/listings/ownership-periods'> => {
  return {
    listingId,
    startAt: startDate ? day(startDate).yyyymmdd() : null,
    endAt: endDate ? day(endDate).yyyymmdd() : null,
    reserve: bankersRound(reserveCentTotal, 0),
    members: members
      .filter((member) => member.ownerId)
      .map((member) => ({
        contactId: member.ownerId!,
        split: member.splitBasePoints,
      })),
    businessModel: businessModel ?? undefined,
  };
};
